export const TRIAL_STATUSES = [
  ['new', 'New'], ['under_review', 'Under review'], ['approved', 'Approved'], ['active', 'Active'],
  ['expired', 'Expired'], ['converted', 'Converted'], ['rejected', 'Rejected'],
];
export const statusLabel = (s) => (TRIAL_STATUSES.find(([v]) => v === s) || [s, s])[1];
const CLS = {
  new: 'badge-open', under_review: 'badge-in-progress', approved: 'badge-medium', active: 'badge-resolved',
  expired: 'badge-closed', converted: 'badge-resolved', rejected: 'badge-critical',
};
export const statusClass = (s) => CLS[s] || '';
